import React from 'react';
import { useSearchParams } from 'react-router-dom';

import TableHeader from '@dashboard/components/table/TableHeader';
import { useSetCurrentPage } from '@dashboard/hooks/route/useCurrentPage';
import { CalendarViewDayOutlined, TableRowsOutlined } from '@mui/icons-material';
import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';

import CreateTemplateButton from './CreateTemplateButton';
import { useCurrentTemplatesQuery } from './hooks';

const DEFAULT_VALUE = 'TEMPLATE';
function castTypeValue(v: unknown) {
  switch (v) {
    case 'LAYOUT':
    case 'TEMPLATE':
      return v;
    default:
      return DEFAULT_VALUE;
  }
}

export default function PageHeader() {
  const { data } = useCurrentTemplatesQuery();
  const res = data?.WaypointTemplates;
  const setPage = useSetCurrentPage();
  const [searchParams, setSearchParams] = useSearchParams();
  const type = castTypeValue(searchParams.get('type'));

  const handleTypeChange = (_: unknown, v: unknown) => {
    setSearchParams((prevParams) => {
      const value = castTypeValue(v);
      if (value === DEFAULT_VALUE) {
        prevParams.delete('type');
      } else {
        prevParams.set('type', value);
      }
      return prevParams;
    });
  };

  return (
    <TableHeader
      limit={res?.meta.limit}
      count={res?.count}
      currentPage={res?.meta.page}
      setPage={setPage}
      title="Templates"
      actions={<CreateTemplateButton />}
      titleActions={
        <Box>
          <Tabs value={type} onChange={handleTypeChange} sx={{ my: -1, '& .MuiTab-root': { height: 52 } }}>
            <Tab
              label={
                <Stack direction="row" spacing={1} alignItems="center">
                  <CalendarViewDayOutlined sx={{ color: 'grey.600' }} />
                  <Typography fontWeight="medium" sx={{ display: { xs: 'none', md: 'block' } }}>
                    Templates
                  </Typography>
                </Stack>
              }
              value="TEMPLATE"
            />
            <Tab
              label={
                <Stack direction="row" spacing={1} alignItems="center">
                  <TableRowsOutlined sx={{ color: 'grey.600' }} />
                  <Typography fontWeight="medium" sx={{ display: { xs: 'none', md: 'block' } }}>
                    Layouts
                  </Typography>
                </Stack>
              }
              value="LAYOUT"
            />
          </Tabs>
        </Box>
      }
    />
  );
}
